import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useCartContext } from '../../context/CartContext';
import { CartPreviewUI } from './CartPreviewUI';
import { GtmService } from "../../../infrastructure/analytics/GtmService";
import { parkCurrentCart } from '../../infrastructure/parkedCartApi';
import { isSuccess } from '../../../common/domain/RemoteData.model';
import { useUserContext } from '../../../user/infrastructure/UserContext';


export function CartPreview({ setModalCar }) {
  const { cart, loading, loadCart, removeProduct, loadCartBis } = useCartContext();
  const user = useUserContext();
  const [parking, setParking] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    loadCart();
  }, [loadCart]);

  const navigateTo = (path) => {
    navigate(path);
    setModalCar(null);
  }

  const handlePlaceOrder = () => {
    GtmService.logBeginCheckout(cart);
    navigateTo('/checkout');
  }

  // Aparca el carrito: las líneas pasan al guardado del cliente efectivo y el
  // carrito queda vacío. Sin reconcile después: el carrito vacío no lo admite.
  const handleParkCart = async () => {
    setParking(true);
    try {
      const result = await parkCurrentCart();
      if (isSuccess(result)) {
        await loadCartBis();
        toast.success('Carrito guardado. Lo tienes en "Carritos guardados".');
      } else {
        toast.error('No se pudo guardar el carrito');
      }
    } catch (error) {
      console.error('Failed to park cart:', error);
      toast.error('No se pudo guardar el carrito');
    } finally {
      setParking(false);
    }
  }

  return (
    <CartPreviewUI cart={cart}
      loading={loading}
      onCatalogClick={() => navigateTo('/articulos')}
      onEditProduct={(product) => navigateTo(`/articulos/${encodeURIComponent(product.code)}`)}
      onDeleteProduct={(product) => removeProduct(product)}
      onPlaceOrder={handlePlaceOrder}
      onParkCart={user?.isComercial === true ? handleParkCart : undefined}
      parking={parking}
    />
  );
}